import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import download from 'downloadjs';

import uuid from 'uuid';

import {
	Pane, Text, toaster,
} from 'evergreen-ui';

import '../../../Briefing/style/prevBriefing.scss';

import api from '../../../../services/api';

import { BriefingsDetails } from './style/BriefingsDetails';

import QuestionTitle from '../../../Briefing/QuestionTitle';
import { ContentTitle } from '../../../utilities/styledComponents/ContentTitle';
import { buildQuestionsAndAnswers } from '../../../../services/briefing/details';
import Interactions from '../Interactions';
import { Box } from '../../../utilities/styledComponents/Box';
import { ButtonBriefing } from '../../../utilities/styledComponents/ButtonBriefing';
import { LoaderPdf as Loader } from '../../../Loader';


export default class BriefingDetails extends Component {
	state = {
		apiResponseData: {},
		dataStep: { questions: [], title: '' },
		dataSteps: [],
		lastStep: 10,
		step: 1,
		uniqueStep: true,
		statusDemand: '',
		checklists: [],
		demandId: '',
		reportLoading: false,
		pdfLoading: false,
	};

	async componentDidMount() {
		const { step, lastStep } = this.state;
		const { match } = this.props;

		await this.buildSteps(match.params.briefingId, step, lastStep);
		window.scrollTo(0, 0);
	}

	createReport = (briefingId) => {
		this.setState({ reportLoading: true });
		api.post('/reports', {
			briefing_id: briefingId,
			report_template_id: 1,
		})
		.then((response) => {
			this.setState({ reportLoading: false });
			if (response.status === 201) {
				const { history } = this.props;
				history.push('/backoffice/relatorios');
			}
		})
		.catch(error => (error)).finally(() => this.setState({ reportLoading: false }));
	}

	URLpdf = (id) => {
		this.setState({ pdfLoading: true });
			api.get(`/briefings/${id}/pdf`, {
			responseType: 'blob',
		})
		.then((response) => {
		const content = response.headers['content-type'];
		download(response.data, 'briefing.pdf', content);
		})
		.catch(error => (error)).finally(() => this.setState({ pdfLoading: false }));
	}

	backToBriefings = () => {
		const { history } = this.props;
		history.push('/backoffice/demandas');
	};

	getStepFromApi = (briefingId, stepId) => {
		api.get(`/briefings/${briefingId}/steps/${stepId}`)
			.then((response) => {
				this.setState({
					apiResponseData: response.data.data,
				}, this.filterResponseApi);
			});
	};

	buildSteps = (briefingId, stepIdInit = 1, stepIdend = 9) => {
		const { uniqueStep } = this.state;
		if (uniqueStep) {
			this.setState({ dataSteps: [] }, () => {
				for (let stepId = stepIdInit; stepId <= stepIdend; stepId += 1) {
					this.getStepFromApi(briefingId, stepId);
				}
			});
		} else {
			for (let stepId = stepIdInit; stepId <= stepIdend; stepId += 1) {
				this.getStepFromApi(briefingId, stepId);
			}
		}
	};

	filterResponseApi = async () => {
		const { apiResponseData, dataSteps } = this.state;
		const titleStep = apiResponseData.relationships.step.attributes.title;
		const questions = buildQuestionsAndAnswers(apiResponseData);
		const dataStep = { questions, title: titleStep };
		dataSteps.push(dataStep);

		return this.setState({
			dataStep,
			dataSteps,
		});
	};

	whoseCreativeIsIt = () => {
		const { apiResponseData } = this.state;
		const answers = apiResponseData.relationships ? apiResponseData.relationships.answers : false;
		if (!answers) {
			return false;
		}

		const creativeAnswer = answers.filter(answer => answer.relationships.question.data.id === '30')[0];
		const resultConfig = {
			color: 'red',
			text: '--',
		};

		if (creativeAnswer) {
			if (creativeAnswer.attributes.content === 'Sim, eu quero!') {
				resultConfig.text = 'Webhub';
				resultConfig.color = 'blue';
			}
			resultConfig.text = 'Cliente';
		}

		return (<Text color={resultConfig.color}>{resultConfig.text}</Text>);
	};

	renderBtnBackToSteps = () => (
		<div className="row">
			<div className="col-12 text-right">
				<button
					type="button"
					className="btn btn-light mt-4"
					onClick={this.backToBriefings}
				>
					Voltar para listagem de briefings
				</button>
			</div>
		</div>
	);

	getDataCustomer = () => {
		const { apiResponseData } = this.state;
		const answers = apiResponseData.relationships ? apiResponseData.relationships.answers : false;
		if (!answers) {
			return false;
		}

		const shopAnswer = answers.filter(answer => answer.relationships.question.data.id === '8')[0];
		return JSON.parse(shopAnswer.attributes.content);
	};

	headerList = (dataBriefing, dataCustomer) => (
		<Pane
			elevation={1}
			padding={16}
		>
			<div className="row">
				{dataBriefing.attributes ? (
					<Fragment>
						<Pane className="col border-right">
							<Text>
								<small>Pré-venda:</small>
							</Text><br />
							<Text>{dataBriefing.attributes.pre_sale_id}</Text>
						</Pane>
						<Pane className="col border-right">
							<Text>
								<small>Nome Cliente:</small>
							</Text><br />
							<Text>{dataCustomer.nome || '----'}</Text>
						</Pane>
						<Pane className="col border-right">
							<Text>
								<small>CNPJ:</small>
							</Text><br />
							<Text size={300}>{dataCustomer.cnpj || '----'}</Text>
						</Pane>
						<Pane className="col border-right">
							<Text>
								<small>Data:</small>
							</Text><br />
							<Text>{dataBriefing.attributes.pre_sale_date || '----'}</Text>
						</Pane>
						<Pane className="col border-right">
							<Text>
								<small>valor:</small>
							</Text><br />
							<Text>R$ {dataBriefing.attributes.sale_net_value ? dataBriefing.attributes.sale_net_value : '----'}</Text>
						</Pane>
						<Pane className="col border-right">
							<Text>
								<small>Peça Gráfica:</small>
							</Text><br />
							{this.whoseCreativeIsIt()}
						</Pane>
						<Pane className="col">
							<button
								type="button"
								className="btn btn-secondary text-white w-100"
								onClick={this.backToBriefings}
							>
								Voltar
							</button>
						</Pane>
					</Fragment>
				) : ''}
			</div>
		</Pane>
	);

	renderStep = dataStep => (
		<Fragment>
			<QuestionTitle titleStep={dataStep.title} target={dataStep.title.replace(/ /g, '_')} />
			<div className="general collapse" id={dataStep.title.replace(/ /g, '_')}>
				{dataStep.questions.map((question) => {
						if (question.answer) {
							return (
								<Fragment key={uuid.v4()}>
									<div className="question">
										<p className="title">{question.title}</p>
										<p className="text pl-3 mb-4">{question.answer}</p>
									</div>
								</Fragment>
							);
						}
						return '';
					})}
			</div>
		</Fragment>
		);

	renderSteps = dataSteps => (
		dataSteps.map(dataStep => this.renderStep(dataStep))
	);

	handleSaveDemand = () => {
		const { demandId, statusDemand, checklists } = this.state;

		const checklistsSelecteds = [];

		checklists.map(checklist => (
			checklist.options.map(option => (
				option.chc ? checklistsSelecteds.push(option.id) : null
			))
		));

		const data = {
			demand_status_id: statusDemand,
			checklists: checklistsSelecteds,
		};

		api.put(`/demands/${demandId}`, data)
			.then(() => {
				toaster.success('Demanda atualizada com sucesso!');
			})
			.catch(() => {
				toaster.danger('Ops! Houve um erro ao atualizar sua demanda.');
			});
	};

	handleCheck = (id) => {
		const { checklists } = this.state;

		const newChecklist = [];

		checklists.map((checklist, indice) => {
			newChecklist.push({
				id: '',
				title: '',
				options: [],
			});

			checklist.options.map((option) => {
				if (option.id === id) {
					option.chc = !option.chc;
				}

				newChecklist[indice].id = checklist.id;
				newChecklist[indice].title = checklist.title;
				newChecklist[indice].options.push(option);
				return newChecklist;
			});

			return null;
		});

		return this.setState({
			checklists: newChecklist,
		});
	};

	render() {
		const {
			dataSteps,
			dataStep,
			uniqueStep,
			apiResponseData,
			reportLoading,
			pdfLoading,
		} = this.state;

		const { match } = this.props;

		return (
			<BriefingsDetails>
				<section className="component-briefing bg-none p-0">
					<div className="content-briefings-details">
						<ContentTitle>
							Detalhes de demanda
							<ButtonBriefing
								type="button"
								onClick={() => this.URLpdf(match.params.briefingId)}
							>
								{ pdfLoading ? (<Loader />) : 'Exportar briefing' }
							</ButtonBriefing>
							<ButtonBriefing
								type="button"
								onClick={() => this.createReport(match.params.briefingId)}
							>
								{ reportLoading ? (<Loader />) : 'Criar relatório' }
							</ButtonBriefing>
						</ContentTitle>
						<div className="container-begin-briefing">
							<div className="container-fluid">
								<div className="row">
									<div className="col-12">
										<Link to="/backoffice/demandas" className="back-to-list">
											{'< Voltar para listagem'}
										</Link>
									</div>

								</div>

								<div className="box-content">
									<header>
										<i className="fa fa-bullhorn" />
										<ContentTitle className="m-0 p-0 title">
											Demanda
										</ContentTitle>
									</header>

									<Box borderRadius="8px 8px 0 0" marginTop="15px">
										{this.headerList(apiResponseData, this.getDataCustomer())}
									</Box>

									<Box marginTop={uniqueStep ? '-48px' : '-50px'} borderRadius="0 0 8px 8px">
										<span className="m-5 d-block" />
										<div className="row">
											<div className="col-12">
												<div className="content-briefing my-0 pt-4">
													{uniqueStep ? this.renderSteps(dataSteps) : this.renderStep(dataStep)}
												</div>
											</div>
										</div>
									</Box>

									{
										(Object.keys(apiResponseData).length > 0) ? (
											<Interactions demandId={apiResponseData.attributes.demand_id} />
										) : null
									}

									{this.renderBtnBackToSteps()}
								</div>
							</div>
						</div>
					</div>
				</section>
			</BriefingsDetails>
		);
	}
}
